/* eslint-disable prettier/prettier */
export const analyzeUsersListCsv = (rows, { hasSnamCompany, hasCdpCompany }) => {
  if (!rows || rows.length === 0) {
    return {
      errorMessage: "Could not load the file, or no data",
    };
  }

  const first = rows[0] || {};
  const keys = Object.keys(first);

  const hasDID = keys.some((k) => String(k).trim() === "DID");
  const hasEmail = keys.some(
    (k) => String(k).trim().toLowerCase() === "email"
  );

  const emailColumnKey =
    hasEmail &&
    keys.find((k) => String(k).trim().toLowerCase() === "email");

  // CDP: only DID column is allowed (Microsoft oid), no email
  if (hasCdpCompany && !hasSnamCompany) {
    if (!hasDID) {
      return {
        errorMessage: "Missing mandatory column: DID is required",
      };
    }

    if (hasEmail) {
      return {
        errorMessage: "Only DID column is allowed for this list",
      };
    }

    const invalidRows = rows.filter((record) => {
      const didValue =
        record.DID !== undefined && record.DID !== null
          ? String(record.DID).trim()
          : "";
      return !didValue;
    });

    if (invalidRows.length > 0) {
      return {
        errorMessage: `${invalidRows.length} record(s) missing required identifier (DID).`,
      };
    }

    return {
      data: rows.map((record) => ({
        DID:
          record.DID !== undefined && record.DID !== null
            ? String(record.DID).trim()
            : "",
      })),
      infoMessage: `${rows.length} records loaded`,
    };
  }

  if (!hasDID && !hasEmail) {
    return {
      errorMessage: "Missing mandatory column: Either DID or EMAIL is required",
    };
  }

  // Non-Snam: DID column is mandatory and must be populated for every record
  if (!hasSnamCompany) {
    if (!hasDID) {
      return {
        errorMessage: "Missing mandatory column: DID is required",
      };
    }

    const invalidRows = rows.filter((record) => {
      const didValue =
        record.DID !== undefined && record.DID !== null
          ? String(record.DID).trim()
          : "";
      return !didValue;
    });

    if (invalidRows.length > 0) {
      return {
        errorMessage: `${invalidRows.length} record(s) missing required identifier (DID).`,
      };
    }
  }

  // Snam:
  // - Either DID or email column is okay
  // - If only DID exists: every record must have DID
  // - If only email exists: every record must have email
  // - If both exist: every record must have both DID and email
  if (hasSnamCompany) {
    if (hasDID && hasEmail) {
      const invalidRows = rows.filter((record) => {
        const didValue =
          record.DID !== undefined && record.DID !== null
            ? String(record.DID).trim()
            : "";
        const emailValue =
          emailColumnKey &&
          record[emailColumnKey] !== undefined &&
          record[emailColumnKey] !== null
            ? String(record[emailColumnKey]).trim()
            : "";
        return !didValue || !emailValue;
      });

      if (invalidRows.length > 0) {
        return {
          errorMessage: `${invalidRows.length} record(s) missing DID and/or Email. For this list, both columns must be populated for every record.`,
        };
      }
    } else if (hasDID && !hasEmail) {
      const invalidRows = rows.filter((record) => {
        const didValue =
          record.DID !== undefined && record.DID !== null
            ? String(record.DID).trim()
            : "";
        return !didValue;
      });

      if (invalidRows.length > 0) {
        return {
          errorMessage: `${invalidRows.length} record(s) missing required identifier (DID).`,
        };
      }
    } else if (!hasDID && hasEmail) {
      const invalidRows = rows.filter((record) => {
        const emailValue =
          emailColumnKey &&
          record[emailColumnKey] !== undefined &&
          record[emailColumnKey] !== null
            ? String(record[emailColumnKey]).trim()
            : "";
        return !emailValue;
      });

      if (invalidRows.length > 0) {
        return {
          errorMessage: `${invalidRows.length} record(s) missing required identifier (Email).`,
        };
      }
    }
  }

  return {
    data: rows,
    infoMessage: `${rows.length} records loaded`,
  };
};
